<template>
  <div class="no-data" @click="addHandle">
    <img src="../../assets/yuyue0.png" alt />
    <div class="text">点击创建直播</div>
  </div>
</template>

<script>
export default {
  name: 'm-no-data',
  methods: {
    addHandle() {
      this.$emit('addHandle')
    }
  }
};
</script>

<style lang="less" scoped>
.no-data {
  position: relative;
  width: 100%;
  // margin-top: 120px;

  img {
    width: 32%;
    padding-top: 120px;
  }

  .text {
    position: absolute;
    left: 0;
    // bottom: 40px;
    width: 100%;
    font-size: 16px;
    color: #777;
    text-align: center;
  }
}
</style>
